export function MFieldError({ message }: { message?: string }) {
	if (!message) return null
	return <p className='mt-1 text-[13px] font-normal text-[#fe2b20] max-md:font-light'>{message}</p>
}
